<template>
  <div>
    <v-alert type="warning" dismissible color="#3c1c64" prominent>
      Arrandi utilise maintenant les emails comme identifiants de connexion. Veuillez utiliser votre email pour vous connecter.
    </v-alert>

    <form class="login" @submit.prevent="handleLogin">
      <h2 id="title">Connexion</h2>
        <input id="email" type="email" v-model="Conn.email" placeholder="Email" title="Veuillez entrer votre email !">
        <div v-if="errors.has('email')"class="alert alert-danger"role="alert"></div>
      
        <input id="password" type="password" v-model="Conn.password"  placeholder="Mot de passe" title="Veuillez entrer votre mot de passe ">
        <div v-if="errors.has('password')" class="alert alert-danger" role="alert"></div>
      
        <button  id="button">Connexion</button>
        
        <label id="forgotPassword" @click="handleForgotPassword">Mot de passe oublié</label>
    </form>
  </div>
</template>

<script>
import Connexion from '../models/connexion';
import Swal from 'sweetalert2';

  export default {
    name: 'Login',
    data () {
      return {
        Conn: new Connexion("", ""),
        loading: false,
        message: '',
      }
    },
    computed: {
      loggedIn () {
        return this.$store.loggedIn
      },
    },
    created () {
      if (this.loggedIn) {
        this.$router.push('/')
      }
    },
    methods: {
      handleForgotPassword() {
        console.log('forgot password')
        this.loading = true
        if (this.Conn.email) {
          this.$store.dispatch('auth/forgotPassword', this.Conn.email).then(
            () => {
              console.log('Un email de réinitialisation vous a été envoyé.')
              Swal.fire('Succès', 'Un email de réinitialisation vous a été envoyé.', 'success');
            },
            error => {
              this.loading = false
              this.message =
                (error.response && error.response.data) ||
                error.message ||
                error.toString() ||
                error.request.response
                Swal.fire('Error', this.message.message, 'error');
            },
          )
        }else{
          alert('Veuillez entrer votre email !');
        }
      },
      handleLogin () {
        this.loading = true
        this.$validator.validateAll().then(isValid => {
          if (!isValid) {
            this.loading = false
            return
          }
          if (this.Conn.email && this.Conn.password) {
            this.$store.dispatch('auth/login', this.Conn).then(
              () => {
                this.$router.push('/#')
              },
              error => {
                this.loading = false
                this.message =
                  (error.response && error.response.data) ||
                  error.message ||
                  error.toString() ||
                  error.request.response
                  Swal.fire('Error', this.message.message, 'error');
              },
            )
          }
          this.Conn.reset()
        })
      },
    },
  }
</script>

<style>
a {
  text-decoration: none;
}

.login {
  max-width: 400px;
  height: 400px;
  margin: 50px  auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
}

#title {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

input {
  width: 100%;
  margin-bottom: 5px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

#forgotPassword {
  display: block;
  text-align: center;
  color: #666;
  margin-top: 20px;
  cursor: pointer;

}

#forgotPassword:hover {
  color: #444;
  text-decoration: underline;
}
#button {
  width: 100%;
  padding: 10px;
  border: none;
  border-radius: 5px;
  background-color: #007bff;
  color: #fff;
  cursor: pointer;
}
#button:hover {
  background-color: #0056b3;
}
.error {
  color: red;
  font-style: italic;
  font-size: 10px;
  margin-bottom: 15px;
}

/* Bellow is original css */

label {
  display: block;
  margin-top: 10px;
}
.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}
.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}
.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}
.form-signin .checkbox {
  font-weight: 400;
}
.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.btn {
  margin: 10px;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  overflow: visible;
  border: #6f42c1;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.try {
  background-color: lightgrey;
  -webkit-border-radius: 2px;
}

</style>
